const AppConstants = {
  DEFAULT_GUID: "00000000-0000-0000-0000-000000000000",
};
export default AppConstants;
